<template lang="pug">
div
  el-row
    el-col(:ms="12")
      h2
        span Литература
        el-button(type="success", icon="el-icon-plus", @click="$router.push(url + '/new')") Добави

  el-form(:model="filters")
    el-row
      el-col(:sm="4")
        el-form-item
          el-select(v-model="filters.type", clearable, placeholder="Всички")
            el-option(label="Налични", value="1")
            el-option(label="Изчерпани", value="2")
      el-col(:sm="4")
        el-form-item
          el-input(v-model="filters.title" placeholder="Заглавие")
      el-col(:sm="4")
        el-form-item
          el-input(v-model="filters.isbn" placeholder="ISBN")
      el-col(:sm="2")
        el-form-item
          el-button(@click="clearFilters") Изчисти

  datatable(ref="datatable", :url="apiUrl", :filters="filters")
    el-table-column(prop="title", label="Заглавие", sortable="custom")
      template(slot-scope="scope")
        router-link(:to="url + '/' + scope.row.id") {{ scope.row.title }} [{{ scope.row.edition }}] ({{ scope.row.isbn }})
    el-table-column(prop="year", label="Година", width="120", sortable="custom")
    el-table-column(prop="numSold", label="Продажби", width="140", sortable="custom")
    el-table-column(prop="numAll", label="Общо", width="120", sortable="custom")
    el-table-column(prop="numLeft", label="Наличност", width="120")
    el-table-column(prop="discount", label="Отстъпка", width="140", sortable="custom", :formatter="percentFormatter")
    el-table-column(prop="price", label="Цена", width="120", sortable="custom", align="right", :formatter="priceFormatter")

</template>

<script>
import Datatable from './Datatable.vue'
import listMixin from '../mixins/listMixin.js'

export default {
  name: 'LiteratureList',
  mixins: [listMixin],
  data () {
    return {
      url: '/literature',
      apiUrl: '/literature',
      filters: {
        type: '',
        title: '',
        isbn: '',
      }
    }
  },
  methods: {

  },
  components: {
    Datatable
  }
}
</script>